/**
 * ExecutionCenter — Mock Data
 * Placeholder data used during UI prototyping and development.
 */

import { WorkflowStage } from '../interfaces/ui';

export const ACTIVITY_MESSAGES = [
  { timestamp: '09:21:02', message: 'Analyzing application structure' },
  { timestamp: '09:21:07', message: 'Generated Authentication module' },
  { timestamp: '09:21:12', message: 'Generated 14 test cases' },
  { timestamp: '09:21:18', message: 'Executing Login validation' },
  { timestamp: '09:21:24', message: 'Captured screenshot' },
  { timestamp: '09:21:31', message: 'Validation passed' },
  { timestamp: '09:21:38', message: 'Executing Logout validation' },
  { timestamp: '09:21:44', message: 'Captured screenshot' },
  { timestamp: '09:21:50', message: 'Validation passed' },
  { timestamp: '09:21:57', message: 'Executing Create Feedback test' },
  { timestamp: '09:22:03', message: 'Captured screenshot' },
  { timestamp: '09:22:09', message: 'Validation passed' },
  { timestamp: '09:22:15', message: 'Compiling execution report' },
];

export const GENERATION_STATUS_MESSAGES = [
  'Analyzing application structure...',
  'Creating validations...',
  'Identifying modules...',
  'Generating scenarios...',
];

export const ANALYSIS_STATUS_MESSAGES = [
  'Analyzing execution results...',
  'Calculating pass/fail metrics...',
  'Identifying failed scenarios...',
  'Detecting auto-healed test cases...',
  'Preparing execution summary...',
];

export const TEST_CASE_NAMES = [
  'Submit Feedback',
  'Approve Feedback',
  'Reject Feedback',
  'Edit Feedback',
  'Delete Feedback',
  'View Analytics',
  'Export Report',
  'Schedule Tests',
  'Configure Settings',
  'Manage Users',
  'Add Team Members',
  'Set Permissions',
  'Create Workflow',
  'Test Integration',
  'Validate Data',
  'Update Settings',
  'Archive Project',
  'Share Results',
  'Download Report',
  'Email Summary',
  'Generate Report',
  'Send Notification',
  'Verify Audit Log',
  'Check Compliance',
  'Update Dashboard',
  'Refresh Cache',
  'Backup Database',
  'Restore Backup',
  'Monitor Performance',
  'Analyze Metrics',
  'Create Alerts',
  'Configure Rules',
  'Test Scenario',
  'Verify Results',
  'Approve Changes',
  'Deploy Update',
];

export const WORKFLOW_STAGES: WorkflowStage[] = [
  { id: '1', label: 'Generate Test Cases', status: 'active' },
  { id: '2', label: 'Execute Tests', status: 'pending' },
  { id: '3', label: 'Analyze Results', status: 'pending' },
  { id: '4', label: 'Results Ready', status: 'pending' },
];
